import { ISidebarMenuSettings } from '../interfaces/sidebar-menu-settings.interface';

export const SIDEBAR_MENU_DEFAULT_SETTINGS: Required<ISidebarMenuSettings> = {
  searchable: true,
  placeholder: 'Pesquisar...',
  isSidebarMini: false,
} as const;
